module.exports = __webpack_public_path__ + "static/media/alphahorizontal.00835741.png";